import { useLayoutEffect, useRef, useEffect } from "react";
import SVG from "react-inlinesvg";

export default function ElectionsTabs({
  menuList = [],
  currentPath = "",
  electionPassedCategory,
}) {
  const containerRef = useRef(null);
  const itemRefs = useRef([]);
  const roRef = useRef(null);

  
  const cleanPath = currentPath ;

  useEffect(() => {
    itemRefs.current = [];
  }, [menuList]);

  const centerSelected = (selectedIndex) => {
    const container = containerRef.current;
    const el = itemRefs.current[selectedIndex];
    if (!container || !el) return;

    const containerRect = container.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();

    const elOffsetLeftRelativeToContainer =
      elRect.left - containerRect.left + container.scrollLeft;

    const targetScroll =
      elOffsetLeftRelativeToContainer -
      (container.clientWidth / 2 - elRect.width / 2);

    const maxScroll = container.scrollWidth - container.clientWidth;
    const clamped = Math.max(0, Math.min(targetScroll, Math.max(0, maxScroll)));

    container.scrollTo({ left: clamped, behavior: "smooth" });
  };

  useLayoutEffect(() => {
    if (!menuList?.length) return;

    const selectedIndex = menuList.findIndex((m) => {
      const isExact = m?.slug === cleanPath;

      const isFallback =
        !menuList.some((x) => x?.slug === cleanPath) &&
        cleanPath.includes("-assembly-constituency-result-") &&
        m?.slug === `${electionPassedCategory}/constituency-list`;

      return isExact || isFallback;
    });

    if (selectedIndex === -1) return;

    centerSelected(selectedIndex);

    const id = setTimeout(() => centerSelected(selectedIndex), 80);

    const container = containerRef.current;
    if (container && typeof ResizeObserver !== "undefined") {
      roRef.current = new ResizeObserver(() =>
        centerSelected(selectedIndex)
      );
      roRef.current.observe(container);

      itemRefs.current.forEach((it) => it && roRef.current.observe(it));
    }

    return () => {
      clearTimeout(id);
      if (roRef.current) {
        try {
          roRef.current.disconnect();
        } catch (e) {}
        roRef.current = null;
      }
    };
  }, [cleanPath, menuList, electionPassedCategory]);

   
  const hasExactMatch = menuList.some((m) => m?.slug === cleanPath);
  const isConstituencyPage = cleanPath.includes(
    "-assembly-constituency-result-"
  );

  return (
    <div
      ref={containerRef}
      className="flex gap-3 flex-row overflow-x-auto scrollbar-hide mt-2 mx-4 md:mx-4 scroll-smooth"
      style={{ WebkitOverflowScrolling: "touch" }}
      role="tablist"
      aria-label="Elections tabs"
    >
      {menuList?.map((item, index) => {
       const getFallbackSlug = (path) => {
  if (!path.includes("-assembly-constituency-result-")) return null;
  const parts = path.split("/");
  return `${parts.slice(0, 4).join("/")}/constituency-list`;
};

const fallbackSlug = getFallbackSlug(cleanPath);

const isSelected =
  item?.slug === cleanPath ||
  (!hasExactMatch && item?.slug === fallbackSlug);

        return (
          <a
            key={item?.slug || index}
            ref={(el) => (itemRefs.current[index] = el)}
            href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}${item?.slug}`}
            className={`${
              isSelected
                ? "bg-primary text-white border-2 border-primary"
                : "border-2 text-gray-600 hover:text-primary"
            } px-3 py-1 rounded-xl whitespace-nowrap flex flex-row items-center gap-1 justify-center`}
            role="tab"
            aria-selected={isSelected ? "true" : "false"}
          >
            <div style={{ minWidth: "1rem" }}>
               
              {item?.src?.includes(".svg") ? (
                <SVG src={item?.src} className="h-4 w-4" />
              ) : (
                <img src={item?.src} className="h-4 w-4" alt="icon" />
              )}
            </div>

            <p>{item?.title}</p>
          </a>
        );
      })}
    </div>
  );
}